import { AccessTokenConfig, AccessTokenFn } from "@me8eon/access_token";
import { calculateTokenRefreshTime, dateTimeService, TimeService } from "@me8eon/time";
import { decodeToken } from "@me8eon/authentication";
import { PublicClientApplication } from "@azure/msal-browser";


export function getAccessTokenFromMsal(msal: PublicClientApplication, scopes: string[]): AccessTokenFn {
    return async (debug, login, storage, timeService) => {
        const loginToken = await login(debug);
        debug("getAccessTokenFromMsal", "login token", loginToken);
        if (!loginToken) return undefined;
        const account = msal.getAllAccounts()[0];
        if (!account) throw new Error("No account found");
        const response = await msal.acquireTokenSilent({ scopes, account });
        debug("getAccessTokenFromMsal", "response", response);
        //Comment: We just logged in. We hope there is a grace period from that login to the token expiry. This code is <1s from the login.
        //We could put try catch logic here... but that is complex, hard to test and it's doubtful if it will every happen
        const token = response.accessToken;
        const accessTokenData = decodeToken(token);
        debug("getAccessTokenFromMsal", token, accessTokenData);
        const expiry = calculateTokenRefreshTime(timeService, accessTokenData.iat, accessTokenData.exp);
        const result = { expiry, token };
        debug("getAccessTokenFromMsal", result);
        return result;
    };
}

export function msalGraphApiAccessTokenConfig(msal: PublicClientApplication, scopes: string[], timeService: TimeService = dateTimeService): AccessTokenConfig {
    return {
        fn: getAccessTokenFromMsal(msal, scopes),
        ttl: 50 * 60 * 1000, //50 mins (the token actually lives for 60)
        timeService,
    };
}
